import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const ReportContext = createContext()

const ReportProvider = ({ children }) => {
    const { headers, toast, restaurantId } = useAuth();

    const reportDashboard = async (startDate, endDate) => {
        try {
            let response = await axios.get(`${baseURL}/reports/dashboard?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Reports Dashboard', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const receiptReport = async (currentPage, rowsPerPage, sortField, sortOrder, startDate, endDate) => {
        try {
            const { data } = await axios.get(`${baseURL}/reports/receipt?sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Receipt Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const singleReceiptReport = async (id) => {
        try {
            let response = await axios.get(`${baseURL}/reports/single-receipt/${id}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Receipt Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const receiptReportCharts = async (startDate, endDate) => {
        try {
            let response = await axios.get(`${baseURL}/reports/receipt/charts?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Receipt Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const receiptReportPDF = async (startDate, endDate, pdfType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/receipt/pdf?startDate=${startDate}&endDate=${endDate}&pdfType=${pdfType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Receipt Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const labourReport = async (startDate, endDate) => {
        try {
            const { data } = await axios.get(`${baseURL}/reports/labour?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Labour Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const labourReportPDF = async (startDate, endDate, pdfType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/labour/pdf?startDate=${startDate}&endDate=${endDate}&pdfType=${pdfType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Labour Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const labourReportCSV = async (startDate, endDate, csvType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/labour/csv?startDate=${startDate}&endDate=${endDate}&csvType=${csvType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Labour Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const HourReport = async (sortField, sortOrder, startDate, endDate) => {
        try {
            const { data } = await axios.get(`${baseURL}/reports/hour?sortField=${sortField}&sortOrder=${sortOrder}&startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Hour Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const hourReportPDF = async (startDate, endDate, pdfType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/hour/pdf?startDate=${startDate}&endDate=${endDate}&pdfType=${pdfType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Hour Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const hourReportCSV = async (startDate, endDate, csvType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/hour/csv?startDate=${startDate}&endDate=${endDate}&csvType=${csvType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Hour Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const dayReport = async (currentPage, rowsPerPage, sortField, sortOrder, startDate, endDate) => {
        try {
            const { data } = await axios.get(`${baseURL}/reports/day?sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Day Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const dayReportCharts = async (startDate, endDate) => {
        try {
            let response = await axios.get(`${baseURL}/reports/day/charts?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Day Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const dayReportPDF = async (startDate, endDate, pdfType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/day/pdf?startDate=${startDate}&endDate=${endDate}&pdfType=${pdfType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Day Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const dayReportCSV = async (startDate, endDate, csvType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/day/csv?startDate=${startDate}&endDate=${endDate}&csvType=${csvType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Day Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const weekReport = async (currentPage, rowsPerPage, sortField, sortOrder, startDate, endDate) => {
        try {
            const { data } = await axios.get(`${baseURL}/reports/week?sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Week Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const weekReportCharts = async (startDate, endDate) => {
        try {
            let response = await axios.get(`${baseURL}/reports/week/charts?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Week Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const weekReportPDF = async (startDate, endDate, pdfType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/week/pdf?startDate=${startDate}&endDate=${endDate}&pdfType=${pdfType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Week Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const weekReportCSV = async (startDate, endDate, csvType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/week/csv?startDate=${startDate}&endDate=${endDate}&csvType=${csvType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Week Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const monthReport = async (currentPage, rowsPerPage, sortField, sortOrder, startDate, endDate) => {
        try {
            const { data } = await axios.get(`${baseURL}/reports/month?sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Month Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const monthReportCharts = async (startDate, endDate) => {
        try {
            let response = await axios.get(`${baseURL}/reports/month/charts?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Month Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const monthReportPDF = async (startDate, endDate, pdfType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/month/pdf?startDate=${startDate}&endDate=${endDate}&pdfType=${pdfType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Month Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const monthReportCSV = async (startDate, endDate, csvType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/month/csv?startDate=${startDate}&endDate=${endDate}&csvType=${csvType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'month Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const categoryReportCharts = async (startDate, endDate) => {
        try {
            let response = await axios.get(`${baseURL}/reports/category/charts?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Category Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const categoryReportPDF = async (startDate, endDate, pdfType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/category/pdf?startDate=${startDate}&endDate=${endDate}&pdfType=${pdfType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Category Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const categoryReportCSV = async (startDate, endDate, csvType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/category/csv?startDate=${startDate}&endDate=${endDate}&csvType=${csvType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Category Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const productReport = async (currentPage, rowsPerPage, sortField, sortOrder, startDate, endDate) => {
        try {
            const { data } = await axios.get(`${baseURL}/reports/product?sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Product Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const productReportCharts = async (startDate, endDate) => {
        try {
            let response = await axios.get(`${baseURL}/reports/product/charts?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Product Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const productReportPDF = async (startDate, endDate, pdfType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/product/pdf?startDate=${startDate}&endDate=${endDate}&pdfType=${pdfType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Product Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const productReportCSV = async (startDate, endDate, csvType) => {
        try {
            let response = await axios.get(`${baseURL}/reports/product/csv?startDate=${startDate}&endDate=${endDate}&csvType=${csvType}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Product Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const userReport = async (currentPage, rowsPerPage, sortField, sortOrder, startDate, endDate) => {
        try {
            const { data } = await axios.get(`${baseURL}/reports/user?sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const userReportCharts = async (startDate, endDate) => {
        try {
            let response = await axios.get(`${baseURL}/reports/user/charts?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const singleUserReport = async (startDate, endDate, userId) => {
        try {
            let response = await axios.get(`${baseURL}/reports/single-user?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}&user_id=${userId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'User Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const tableReport = async (currentPage, rowsPerPage, sortField, sortOrder, startDate, endDate) => {
        try {
            const { data } = await axios.get(`${baseURL}/reports/table?sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Table Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const tableReportCharts = async (startDate, endDate) => {
        try {
            let response = await axios.get(`${baseURL}/reports/table/charts?startDate=${startDate}&endDate=${endDate}&restaurant_id=${restaurantId}`, { headers })
            if (response.data.error === false) {
                return response.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Table Reports', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <ReportContext.Provider value={{
            reportDashboard,
            receiptReport,
            singleReceiptReport,
            receiptReportCharts,
            receiptReportPDF,
            labourReport,
            labourReportPDF,
            labourReportCSV,
            HourReport,
            hourReportPDF,
            hourReportCSV,
            dayReport,
            dayReportCharts,
            dayReportPDF,
            dayReportCSV,
            weekReport,
            weekReportCharts,
            weekReportPDF,
            weekReportCSV,
            monthReport,
            monthReportCharts,
            monthReportPDF,
            monthReportCSV,
            categoryReportCharts,
            categoryReportPDF,
            categoryReportCSV,
            productReport,
            productReportCharts,
            productReportPDF,
            productReportCSV,
            userReport,
            userReportCharts,
            singleUserReport,
            tableReport,
            tableReportCharts
        }}>
            {children}
        </ReportContext.Provider>
    )
}

const useReport = () => useContext(ReportContext)

export { useReport, ReportProvider }